// extracted by mini-css-extract-plugin
export default {"resetPassword":"Profile_resetPassword__rkfWR","control":"Profile_control__dkJIP","icon":"Profile_icon__AtgWb","action":"Profile_action__43Cqg","btn":"Profile_btn__vm2K2"};